import $ from 'jquery';
import log from 'lib/logger';
import ApplicationController from './application_controller';

/**
 * Drives the JetStream notifications index: the "check all" checkbox in the
 * table header and the per-row completion checkboxes, PATCHing the
 * batch-update form whenever they change.
 *
 * This replaces an inline turbo:load script that registered document-level
 * handlers on every Turbo visit without ever removing them, so after N
 * visits a single click fired N duplicate PATCH requests and the bulk-update
 * guard flag (scoped per closure) no longer worked. Handlers are delegated
 * from the controller element, which Turbo replaces on every body swap, so
 * exactly one live handler exists at any time.
 */
export default class extends ApplicationController {
  connect() {
    this.bulkUpdating = false; // Flag to track bulk updates

    this.onCheckAllChange = (event) => {
      this.bulkUpdating = true;

      const checkAll = $(event.currentTarget);
      // Check or uncheck all notification checkboxes
      this.checkboxes().prop('checked', checkAll.is(':checked'));

      $.ajax({
        url: checkAll.closest('form').attr('action'),
        type: 'PATCH',
        data: checkAll.closest('form').serialize(),
        dataType: 'json',
        success: () => {
          this.bulkUpdating = false; // Reset flag after AJAX completes
        },
        error: () => {
          this.bulkUpdating = false; // Ensure to reset flag even on error
        },
      });
    };

    this.onCheckboxChange = (event) => {
      if (!this.bulkUpdating) {
        // Only make AJAX call if not in a bulk update process
        const form = $(event.currentTarget).closest('form');
        $.ajax({
          url: form.attr('action'),
          type: 'PATCH',
          data: form.serialize(),
          dataType: 'json',
          error: (jqXHR, textStatus, errorThrown) => {
            log.error('Error updating a single checkbox', textStatus, errorThrown);
          },
        });
      }

      // Uncheck "Check All" if any notification checkbox is unchecked manually
      if (this.checkboxes(':checked').length !== this.checkboxes().length) {
        this.checkAllCheckbox().prop('checked', false);
      }
    };

    $(this.element).on('change', '#check_all_notifications', this.onCheckAllChange);
    $(this.element).on('change', '.jetstream-checkbox', this.onCheckboxChange);

    // Set the initial state of the "Check All" checkbox
    this.updateCheckAllCheckbox();
  }

  disconnect() {
    $(this.element).off('change', '#check_all_notifications', this.onCheckAllChange);
    $(this.element).off('change', '.jetstream-checkbox', this.onCheckboxChange);
  }

  checkboxes(filter = '') {
    return $(`.jetstream-checkbox${filter}`, this.element);
  }

  checkAllCheckbox() {
    return $('#check_all_notifications', this.element);
  }

  // Check the "Check All" checkbox when every individual checkbox is checked
  updateCheckAllCheckbox() {
    const total = this.checkboxes().length;
    if (total > 0) {
      this.checkAllCheckbox().prop('checked', total === this.checkboxes(':checked').length);
    }
  }
}
